import { userType } from "../../DTO";
import { Api } from "../api";

export const EditLesson = (
    user: userType,
    lessonId: number,
    title: string,
    description: string,
    timeToRead: number,
    attachments: number[],
) => {
    return new Promise<{ data: any }>((resolve, reject) => {
        const api = new Api({
            method: "post",
            path: `lesson/${lessonId}/edit`,
            header: {
                Authorization: `Bearer ${user.access_token}`,
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                title,
                description,
                time_to_read: timeToRead,
                attachment_ids: attachments,
            }),
        });

        return api
            .call()
            .then((data: any) => {
                return resolve({
                    data,
                });
            })
            .catch((error: any) => reject(error.data.message));
    });
};
